import React from "react";
import { Styles } from "./styles";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register the required Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const PaymentMethods = ({ methodsStats }) => {
  // Map the API data to the chart data format
  const labelsMap = {
    cryptomus: "cryptomus",
    payeer: "payeer",
  };

  // Generate labels and data dynamically
  const labels = methodsStats.map(
    (stat) => labelsMap[stat.payment_method] || stat.payment_method
  );
  const dataCount = methodsStats.map((stat) => stat.total);

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Payment methods Statistics",
        data: dataCount,
        backgroundColor: [
          "#114787",
          "#58A4B0",
        ],
        borderColor: [
          "#114787",
          "#58A4B0",
        ],
        borderWidth: 1,
      },
    ],
  };

  // Options for the Doughnut Chart
  const options = {
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        enabled: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <Styles>
      <div
        style={{
          width: "300px",
          height: "300px",
          margin: "0 auto",
          marginTop: "20px",
        }}
      >
        <div className="title mb-2">{data?.datasets[0]?.label}</div>
        <Doughnut data={data} options={options} />
      </div>
    </Styles>
  );
};

export default PaymentMethods;
